import { useI18n } from './I18nContext'
import { TranslationKeys } from './translations'

export function useTranslation() {
  const { t } = useI18n()
  return {
    t: t as (key: keyof TranslationKeys, params?: Record<string, string | number>) => string,
  }
}

export function useLanguage() {
  const { language, setLanguage, availableLanguages } = useI18n()
  return { language, setLanguage, availableLanguages }
}
